import { apiFetch } from "../api.js";
import type {
  CreateHousingUnitInput,
  HousingUnit,
  HousingUnitsListResponse,
  UpdateHousingUnitInput,
} from "./types.js";

export function listHousingUnits(
  includeArchived = false,
): Promise<HousingUnitsListResponse> {
  const qs = includeArchived ? "?include_archived=true" : "";
  return apiFetch<HousingUnitsListResponse>(`/v1/housing-units${qs}`);
}

export function getHousingUnit(unitId: string): Promise<HousingUnit> {
  return apiFetch<HousingUnit>(`/v1/housing-units/${unitId}`);
}

export function createHousingUnit(
  input: CreateHousingUnitInput,
): Promise<HousingUnit> {
  return apiFetch<HousingUnit>("/v1/housing-units", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateHousingUnit(
  unitId: string,
  input: UpdateHousingUnitInput,
): Promise<HousingUnit> {
  return apiFetch<HousingUnit>(`/v1/housing-units/${unitId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function deleteHousingUnit(unitId: string): Promise<void> {
  return apiFetch<void>(`/v1/housing-units/${unitId}`, { method: "DELETE" });
}
